<template>
    <div>
        <!-- <h1 class="subtitulo mt-5">Lineamientos</h1>
            <h2 class="subtitulo2"> (Desagregación Programática)</h2> -->
                    <h2 class="subtitulo2 mt-5"><p class="m-0">Lineamientos (Desagregación Programática)</p></h2>
                    <div class="card card-width">
                        <div class="card-body">
                            <span class="parrafo_lineamientos">
                                <p>
                                    Instrumentos Normativos para la Formulación del Anteproyecto de Presupuesto de Egresos, así como los Lineamientos Normativos de los Programas de Inversión Estatal; como se muestra a continuación:
                                </p>
                                <!--<a class="mb-2" style="color:#000000!important; font-size:13px!important; text-decoration:none!important;" :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Normativos/SAPE-23.pdf'">Proceso de Envío – SAPE 2023</a>-->
                            </span>
                            <div class="row">
                                <div class="col-7">
                                    <select v-model="selected" class="custom-select custom-select-lg">
                                        <option>Consultar año</option>
                                        <option>2024</option>
                                        <option>2023</option>
                                        <option>2022</option>
                                        <option>2021</option>
                                        <option>2020</option>
                                        <option>2019</option>
                                        <option>2018</option>
                                        <option>2017</option>
                                        <option>2016</option>
                                        <option>2015</option>
                                        <option>2014</option>
                                        <option>2013</option>
                                        <option>2012</option>
                                        <option>2011</option>
                                        <option>2010</option>
                                        <option>2009</option>
                                        <option>2008</option>
                                        <option>2007</option>
                                        <option>2006</option>
                                    </select>
                                </div>
                                <div class="col-5">
                                    <button @click="consulta" class="btn btn-vino btn-block">Consultar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <archivos-ldp :anio="anio"></archivos-ldp>

    </div>
</template>
<script>
import archivosLdp from './archivos-LDP-anios.vue';

export default {
    components:{
        archivosLdp
    },
    data: function(){
        return{
            selected: 'Consultar año',
            anio: ''
        }
    },
    methods:{
        consulta(){
            if (this.selected > 1) {
                this.anio = this.selected
            }
        }
    }
}
</script>
<style scoped>
.parrafo_lineamientos{
    font-size:13px; 
    text-align: justify;
}
@media only screen and (max-device-width : 900px) {
    .btn{
        padding: .5rem .9rem;
        font-size: .7rem;
    }
}

</style>
